module.exports = __webpack_public_path__ + "img/product-xjg-3487.c85dba78.png";